<template>
	<div class="service-tokens">
		<ServiceTokensPanel v-if="canManageServiceTokens" :api-token="store.userApiToken" />
	</div>
</template>
<script setup lang="ts">
import { computed, onMounted } from "vue"
import { useRouter } from "vue-router"
import ServiceTokensPanel from "@/components/admin/ServiceTokensPanel.vue"
import { Permission, UseRootStore } from "@/model/RootStore"
import { Route } from "@/utils/routing"

const router = useRouter()
const store = UseRootStore()
const canManageServiceTokens = computed(() => store.currentUser?.has(Permission.ServiceTokenWrite) ?? false)

onMounted(() => {
	if (!canManageServiceTokens.value) router.push({ name: Route.Admin })
})
</script>
